export enum TourTypeEnum {
  Tour = 1,
  Video = 2,
}
